module.exports = __webpack_public_path__ + "img/slide3.4cc4917b.png";